export const SCREENING_STATUS = {
  ANALYZING: 'ANALYZING',
  AI_INTERVIEW_CREATED: 'AI_INTERVIEW_CREATED',
  AI_INTERVIEW_LINK_SENT: 'AI_INTERVIEW_LINK_SENT',
  SCREENING_ERROR: 'SCREENING_ERROR',
  SCREENING_COMPLETED: 'SCREENING_COMPLETED',
  AI_INTERVIEW_IN_PROGRESS: 'AI_INTERVIEW_IN_PROGRESS',
  AI_INTERVIEW_EVALUATED: 'AI_INTERVIEW_EVALUATED',

};

export const PRE_SCREENING_RESPONSE_TYPES = {
  BOOLEAN: 'BOOLEAN',
  NUMERIC: 'NUMERIC',
  TEXT: 'TEXT',
};
